import * as React from 'react';

import type { FluxibleContext } from 'fluxible';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';
import FluxibleComponent from 'vendor/cnpm/fluxible.v0-4/addons/FluxibleComponent';

import mapProps from 'js/lib/mapProps';

import app from 'bundles/discussions/app';
import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';
import DiscussionsWeekHeroUnit from 'bundles/discussions/components/personalization-DiscussionsWeekHeroUnit';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type OnDemandCourseForumStatisticsV1 from 'bundles/naptimejs/resources/onDemandCourseForumStatistics.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type OnDemandCourseForumsV1 from 'bundles/naptimejs/resources/onDemandCourseForums.v1';
import { getCurrentWeek } from 'bundles/ondemand/stores/StoreComputationHelpers';
import waitForStores from 'bundles/phoenix/lib/waitForStores';

type PropsFromCaller = {
  weekNumber?: number;
};

type PropsFromDiscussionsForumsHoc = {
  courseForums: OnDemandCourseForumsV1;
  courseForumStatistics: OnDemandCourseForumStatisticsV1;
};

type PropsToMapProps = PropsFromCaller & PropsFromDiscussionsForumsHoc;

type PropsFromMapProps = {
  forum: OnDemandCourseForumsV1;
  forumStatistic: OnDemandCourseForumStatisticsV1;
};

type PropsFromFluxibleWrapper = {
  isCourseWeekPage: boolean;
};

type PropsToConnector = PropsFromCaller & PropsFromFluxibleWrapper;

type PropsToComponent = PropsFromCaller & PropsFromDiscussionsForumsHoc & PropsFromMapProps & PropsFromFluxibleWrapper;

const DiscussionsCurrentWeekLoader = (props: PropsToComponent) => {
  const { weekNumber, forum, forumStatistic } = props;

  if (!weekNumber || !forum) {
    return null;
  }

  return (
    <DiscussionsWeekHeroUnit
      weekNumber={weekNumber}
      isLoading={false}
      title={forum.title}
      description={forum.description}
      lastAnsweredAt={forumStatistic && forumStatistic.lastAnsweredAt}
      forumQuestionCount={forumStatistic && forumStatistic.forumQuestionCount}
    />
  );
};

const DiscussionsCurrentWeekLoaderConnector = compose<PropsToComponent, PropsToConnector>(
  discussionsForumsHOC({
    fields: ['link', 'title', 'forumType', 'description', 'lastAnsweredAt', 'forumQuestionCount'],
  }),
  waitForStores(
    ['CourseStore', 'CourseScheduleStore', 'ProgressStore'],
    ({ CourseStore, CourseScheduleStore, ProgressStore }: $TSFixMe, props: $TSFixMe) => {
      const weekNumber = props.weekNumber || getCurrentWeek(CourseStore, CourseScheduleStore, ProgressStore);
      return {
        weekNumber,
      };
    }
  ),
  mapProps<PropsFromMapProps, PropsToMapProps>((props) => {
    const forum = props.courseForums.find(
      (courseForum: $TSFixMe) => courseForum.forumType.definition.weekNumber === props.weekNumber
    );

    return {
      ...props,
      forum,
      forumStatistic:
        forum &&
        props.courseForumStatistics &&
        props.courseForumStatistics.find((statistic: $TSFixMe) => statistic.courseForumId === forum.id),
    };
  })
)(DiscussionsCurrentWeekLoader);

export default class FluxibleDiscussionsAppLoader extends React.Component<PropsFromCaller> {
  static contextTypes = {
    fluxibleContext: PropTypes.object,
  };

  declare context: LegacyContextType<typeof FluxibleDiscussionsAppLoader.contextTypes>;

  componentWillMount() {
    const { fluxibleContext } = this.context;
    this.fluxibleContext = app(fluxibleContext);
  }

  fluxibleContext: FluxibleContext | undefined = undefined;

  render() {
    return (
      <FluxibleComponent context={this.fluxibleContext?.getComponentContext()}>
        <DiscussionsCurrentWeekLoaderConnector {...this.props} isCourseWeekPage />
      </FluxibleComponent>
    );
  }
}
